import { BrowserRouter } from 'react-router-dom';
import type { ReactNode } from 'react';

interface AppRouterProps {
  children: ReactNode;
}

export function AppRouter({ children }: AppRouterProps): JSX.Element {
  return <BrowserRouter>{children}</BrowserRouter>;
}
